(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-corewrap-buy-box"] && !Shopify.designMode) return;
  try {
    
  // Delegated handlers on document so they survive Shopify theme-editor section
  // reloads and never depend on per-element re-binding. One set of listeners
  // serves every .cw-buy section on the page.

  function cwShowSlide(root, target) {
    var stageEl = root.querySelector('[data-buy-stage]');
    if (!stageEl) return;
    var slides = stageEl.querySelectorAll('.cw-buy__slide');
    if (!slides.length) return;
    var thumbs = root.querySelectorAll('[data-buy-thumb]');
    var n = slides.length;
    var idx = ((target % n) + n) % n;
    slides.forEach(function (s, j) { s.classList.toggle('is-active', j === idx); });
    thumbs.forEach(function (t) { t.classList.toggle('is-active', parseInt(t.getAttribute('data-index'), 10) === idx); });
  }

  function cwCurrentSlide(root) {
    var stageEl = root.querySelector('[data-buy-stage]');
    var current = 0;
    if (stageEl) {
      stageEl.querySelectorAll('.cw-buy__slide').forEach(function (s, j) {
        if (s.classList.contains('is-active')) { current = j; }
      });
    }
    return current;
  }

  // Gallery: thumbnails + prev/next arrows (toggle which stacked slide is visible —
  // no src/srcset swap, which a responsive image_tag srcset would override).
  document.addEventListener('click', function (e) {
    var control = e.target.closest('[data-buy-thumb], [data-buy-prev], [data-buy-next]');
    if (!control) return;
    var root = control.closest('.cw-buy');
    if (!root) return;
    e.preventDefault();
    if (control.hasAttribute('data-buy-thumb')) {
      cwShowSlide(root, parseInt(control.getAttribute('data-index'), 10) || 0);
    } else if (control.hasAttribute('data-buy-prev')) {
      cwShowSlide(root, cwCurrentSlide(root) - 1);
    } else if (control.hasAttribute('data-buy-next')) {
      cwShowSlide(root, cwCurrentSlide(root) + 1);
    }
  });

  // Pack + colour selection (delegated 'change').
  function cwReadout(form, packId) {
    var group = form.querySelector('[data-colour-group="' + packId + '"]');
    if (!group) return;
    var readout = group.querySelector('[data-colour-readout]');
    var checked = group.querySelector('.cw-buy__colour-input:checked');
    if (readout && checked) { readout.textContent = checked.dataset.label || ''; }
  }

  function cwActivatePack(form, packId) {
    form.querySelectorAll('[data-colour-group]').forEach(function (group) {
      var inputs = group.querySelectorAll('.cw-buy__colour-input');
      if (group.getAttribute('data-colour-group') === packId) {
        group.classList.remove('is-hidden');
        var anyChecked = false;
        inputs.forEach(function (inp) { inp.disabled = false; if (inp.checked) { anyChecked = true; } });
        if (!anyChecked && inputs.length) { inputs[0].checked = true; }
        cwReadout(form, packId);
      } else {
        group.classList.add('is-hidden');
        inputs.forEach(function (inp) { inp.disabled = true; inp.checked = false; });
      }
    });
    form.querySelectorAll('.cw-buy__colour-input--single').forEach(function (single) {
      var on = single.getAttribute('data-group') === packId;
      single.disabled = !on;
      single.checked = on;
    });
  }

  document.addEventListener('change', function (e) {
    var target = e.target;
    if (!target) return;
    var form = target.closest('.cw-buy__form');
    if (!form) return;
    if (target.classList.contains('cw-buy__pack-input')) {
      if (target.checked) { cwActivatePack(form, target.value); }
    } else if (target.classList.contains('cw-buy__colour-input')) {
      var group = target.closest('[data-colour-group]');
      if (group) { cwReadout(form, group.getAttribute('data-colour-group')); }
    }
  });

  // Initialise each buy box from its server-checked pack (live load + editor reload).
  function cwInit(scope) {
    (scope || document).querySelectorAll('.cw-buy .cw-buy__form').forEach(function (form) {
      var initial = form.querySelector('.cw-buy__pack-input:checked');
      if (initial) { cwActivatePack(form, initial.value); }
    });
  }
  if (document.readyState !== 'loading') { cwInit(); }
  else { document.addEventListener('DOMContentLoaded', function () { cwInit(); }); }
  document.addEventListener('shopify:section:load', function (e) { cwInit(e.target); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-corewrap-hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-cw-slider]').forEach(function (slider) {
    var track = slider.querySelector('[data-slides]');
    if (!track) return;
    var dots = Array.prototype.slice.call(slider.querySelectorAll('[data-dot]'));
    var prev = slider.querySelector('[data-slide-prev]');
    var next = slider.querySelector('[data-slide-next]');
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function width() { return track.clientWidth || 1; }
    function current() { return Math.round(track.scrollLeft / width()); }
    function goTo(i) {
      var max = track.children.length - 1;
      if (i < 0) i = max;
      if (i > max) i = 0;
      track.scrollTo({ left: i * width(), behavior: reduced ? 'auto' : 'smooth' });
    }
    function sync() {
      var i = current();
      dots.forEach(function (d, n) {
        if (n === i) { d.setAttribute('aria-current', 'true'); } else { d.removeAttribute('aria-current'); }
      });
    }

    if (prev) prev.addEventListener('click', function () { goTo(current() - 1); });
    if (next) next.addEventListener('click', function () { goTo(current() + 1); });
    dots.forEach(function (d, n) {
      d.addEventListener('click', function () { goTo(n); });
    });

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(function () { ticking = false; sync(); });
      }
    }, { passive: true });

    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(current() - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current() + 1); }
    });

    sync();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-corewrap-offer"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.cw-offer__opts').forEach(function (set) {
    var readout = set.querySelector('[data-opt-readout]');
    if (!readout) return;
    set.addEventListener('change', function (e) {
      if (e.target && e.target.classList.contains('cw-offer__opt-input')) {
        readout.textContent = e.target.dataset.label || '';
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-corewrap-sticky-cta"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.cw-sticky').forEach(function (bar) {
    var threshold = parseInt(bar.dataset.threshold, 10) || 600;
    var dismissed = false;
    var ticking = false;
    var blockerVisible = {};

    function anyBlockerVisible() {
      for (var key in blockerVisible) {
        if (blockerVisible[key]) return true;
      }
      return false;
    }

    function update() {
      ticking = false;
      var pastThreshold = window.scrollY > threshold;
      var show = pastThreshold && !dismissed && !anyBlockerVisible();
      bar.setAttribute('data-visible', show ? 'true' : 'false');
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    }

    window.addEventListener('scroll', function () {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(update);
      }
    }, { passive: true });

    var hideSelectors = [];
    if (bar.dataset.hideNearFinal === 'true') hideSelectors.push('.cw-cta');
    if ('IntersectionObserver' in window) {
      hideSelectors.forEach(function (sel) {
        var el = document.querySelector(sel);
        if (!el) return;
        new IntersectionObserver(function (entries) {
          blockerVisible[sel] = entries[0].isIntersecting;
          update();
        }, { threshold: 0.15 }).observe(el);
      });
    }

    var dismissBtn = bar.querySelector('[data-dismiss]');
    if (dismissBtn) {
      dismissBtn.addEventListener('click', function () {
        dismissed = true;
        update();
      });
    }

    var scrollBtn = bar.querySelector('[data-scroll-to-buybox]');
    if (scrollBtn) {
      scrollBtn.addEventListener('click', function () {
        // Always send the shopper back to the buy box to pick pack + colour.
        // Fall back to the offer section, then the page top, if the buy box isn't found.
        var target = document.querySelector('.cw-buy') || document.body;
        var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
      });
    }

    update();
  });

  } catch(e) { console.error(e); }
})();
})();
